import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StoreService } from 'src/app/store.service';
import { UtilitiesService } from 'src/app/core/utilities.service';
import { DealerService } from 'src/app/dealer.service';

@Component({
  selector: 'app-profile-preference',
  templateUrl: './profile-preference.component.html',
  styleUrls: ['./profile-preference.component.scss'],
})
export class ProfilePreferenceComponent implements OnInit {
  bearer: string = '';
  store_id: string = '';
  dealer: any = null;

  accountSettingForm: FormGroup;
  companyDetailsForm: FormGroup;
  companyAddressForm: FormGroup;

  dealer_id: any;
  dealer_name: string = '';
  dealer_addresses: any;
  dealer_email: string = '';
  dealer_phone: string = '';
  dealer_company_email: string = '';
  dealer_company_name: string = '';
  dealer_company_addresses: any = {};
  dealer_company_phone: string = '';

  city: string = '';
  state: string = '';
  postal: string = '';
  street: string = '';
  country: string = '';

  edit1 = false;
  edit3 = false;
  edit4 = false;

  isLoading = true;

  showloader1 = false;
  showloader3 = false;
  showloader4 = false;

  accountSettingDisable = false;
  companyDetailsDisable = false;
  companyAddressDisable = false;

  errorMsg: any = '';

  dealer$ = this.dealerService.getDealer();

  get userInitials(): string {
    if (!this.dealer_name) {
      return (this.dealer_company_name ? this.dealer_company_name.substring(0, 2).toUpperCase() : 'ME');
    }
    const parts = this.dealer_name.trim().split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return this.dealer_name.substring(0, 2).toUpperCase();
  }

  get isProfileComplete(): boolean {
    return !!(this.dealer_name && this.dealer_email && this.dealer_phone);
  }

  get isAddressComplete(): boolean {
    return !!(this.street && this.city && this.country);
  }

  constructor(
    private svc: StoreService,
    private formBuilder: FormBuilder,
    private utils: UtilitiesService,
    private dealerService: DealerService
  ) {
    this.buildForm();
    this.uiTheme = this.utils.getUiTheme();
  }

  // Dashboard theme, per browser (see UtilitiesService.setUiTheme).
  uiTheme: 'glass' | 'classic' = 'glass';

  selectUiTheme(theme: 'glass' | 'classic') {
    this.uiTheme = theme;
    this.utils.setUiTheme(theme);
  }

  buildForm() {
    this.accountSettingForm = this.formBuilder.group({
      dealer_name: ['', Validators.required],
      dealer_email: ['', Validators.required],
      dealer_phone: ['', Validators.required],
    });
    this.companyDetailsForm = this.formBuilder.group({
      dealer_company_name: ['', Validators.minLength(5)],
      dealer_company_email: ['', Validators.minLength(6)],
    });
    this.companyAddressForm = this.formBuilder.group({
      dealer_company_addresses: [''],
      street: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      postal: ['', Validators.required],
      country: ['', Validators.required],
      dealer_company_phone: [''],
    });

    this.bindFormChangeListeners();
  }

  bindFormChangeListeners() {
    this.accountSettingForm.valueChanges.subscribe(() => {
      this.accountSettingFormChange();
    });
    this.companyDetailsForm.valueChanges.subscribe(() => {
      this.companyDetailsFormChange();
    });
    this.companyAddressForm.valueChanges.subscribe(() => {
      this.companyAddressFormChange();
    });
  }

  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer') || '';
    this.store_id = localStorage.getItem('store_id') || '';
    this.getDealerInfo();
  }

  getDealerInfo() {
    this.dealer$.subscribe({
      next: (res) => {
        if (!res) return;
        this.dealer = res;
        this.isLoading = false;
        this.dealer_id = res?.dealer_id;
        this.dealer_name = res?.dealer_name || '';
        this.dealer_addresses = res?.dealer_addresses;
        this.dealer_email = res?.dealer_email || '';
        this.dealer_phone = res?.dealer_phone || '';
        this.dealer_company_name = res?.dealer_company_name || '';
        this.dealer_company_email = res?.dealer_company_email || '';
        this.dealer_company_phone = res?.dealer_company_phone || '';

        if (typeof res.dealer_company_addresses === 'string') {
          try {
            this.dealer_company_addresses = JSON.parse(res.dealer_company_addresses);
          } catch (error) {
            console.error('Error parsing dealer_company_addresses string:', error);
            this.dealer_company_addresses = {};
          }
        } else if (typeof res.dealer_company_addresses === 'object' && res.dealer_company_addresses !== null) {
          this.dealer_company_addresses = res.dealer_company_addresses;
        } else {
          this.dealer_company_addresses = {};
        }

      this.city = this.dealer_company_addresses.city || '';
      this.state = this.dealer_company_addresses.state || '';
      this.postal = this.dealer_company_addresses.postal || '';
      this.street = this.dealer_company_addresses.street || '';
      this.country = this.dealer_company_addresses.country || '';

      this.accountSettingForm.patchValue({
        dealer_name: this.dealer_name,
        dealer_email: this.dealer_email,
        dealer_phone: this.dealer_phone,
      }, { emitEvent: false });

      this.companyDetailsForm.patchValue({
        dealer_company_name: this.dealer_company_name,
        dealer_company_email: this.dealer_company_email,
      }, { emitEvent: false });

      this.companyAddressForm.patchValue({
        dealer_company_addresses: this.dealer_company_addresses,
        street: this.street,
        city: this.city,
        state: this.state,
        postal: this.postal,
        country: this.country,
        dealer_company_phone: this.dealer_company_phone,
      }, { emitEvent: false });

        this.accountSettingDisable = false;
        this.companyDetailsDisable = false;
        this.companyAddressDisable = false;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  updateDealerInfo(form: number) {
    const address = {
      city: this.companyAddressForm.value['city'],
      state: this.companyAddressForm.value['state'],
      postal: this.companyAddressForm.value['postal'],
      street: this.companyAddressForm.value['street'],
      country: this.companyAddressForm.value['country'],
    };
    this.dealer_company_addresses = JSON.stringify(address);

    if (!this.accountSettingForm.value['dealer_name']) {
      this.utils.notify.showError(this.utils.translate('Account Name is required'));
      return;
    }
    if (!this.accountSettingForm.value['dealer_email']) {
      this.utils.notify.showError(this.utils.translate('Account Email is required'));
      return;
    }
    if (!this.accountSettingForm.value['dealer_phone']) {
      this.utils.notify.showError(this.utils.translate('Account Phone Number is required'));
      return;
    }
    if (isNaN(this.accountSettingForm.value['dealer_phone'])) {
      this.utils.notify.showError(this.utils.translate('Please enter valid phone number'));
      return;
    }

    if (
      this.companyAddressForm.value['dealer_company_phone'] &&
      isNaN(this.companyAddressForm.value['dealer_company_phone'])
    ) {
      this.utils.notify.showError(this.utils.translate('Please enter valid phone number'));
      return;
    }

    switch (form) {
      case 1:
        this.showloader1 = true;
        break;
      case 3:
        this.showloader3 = true;
        break;
      case 4:
        this.showloader4 = true;
        break;
    }

    const updatedDealerInfo = {
      dealer_company_addresses: JSON.parse(this.dealer_company_addresses),
      dealer_addresses: this.dealer_addresses,
      dealer_name: this.accountSettingForm.value['dealer_name'],
      dealer_phone: this.accountSettingForm.value['dealer_phone'],
      dealer_email: this.accountSettingForm.value['dealer_email'],
      dealer_company_name: this.companyDetailsForm.value['dealer_company_name'],
      dealer_company_phone: this.companyAddressForm.value['dealer_company_phone'],
      dealer_company_email: this.companyDetailsForm.value['dealer_company_email'],
    };

    this.svc
      .updateDealerInfo(
        this.bearer,
        this.dealer_id,
        this.accountSettingForm.value['dealer_name'],
        this.dealer_addresses,
        this.accountSettingForm.value['dealer_phone'],
        this.accountSettingForm.value['dealer_email'],
        this.companyDetailsForm.value['dealer_company_name'],
        this.dealer_company_addresses,
        this.companyAddressForm.value['dealer_company_phone'],
        this.companyDetailsForm.value['dealer_company_email']
      )
      .subscribe(
        (data) => {
          this.dealerService.updateDealerInfo(updatedDealerInfo);
          setTimeout(() => {
            this.utils.notify.showSuccess(this.utils.translate('Updated Successfully!'));
            this.getDealerInfo();
            this.hideLoader();
            this.editForm(form, false);
          }, 1000);
        },
        (error) => {
          console.error(error);
          this.errorMsg = error?.error?.message;
          this.utils.notify.showError(this.utils.translate('Update Failed!'));
          this.hideLoader();

          if (typeof this.errorMsg === 'object' && this.errorMsg !== null) {
            let msg = '';
            Object.keys(this.errorMsg).forEach((key) => {
              msg += this.errorMsg[key] + '\n';
            });
            this.utils.notify.showError(msg);
          }
        }
      );
  }

  hideLoader() {
    this.showloader1 = false;
    this.showloader3 = false;
    this.showloader4 = false;
  }

  editForm(form: number, edit = true) {
    (this as any)[`edit${form}`] = edit;
    if (!edit) {
      switch (form) {
        case 1:
          this.accountSettingForm.patchValue({
            dealer_name: this.dealer_name,
            dealer_email: this.dealer_email,
            dealer_phone: this.dealer_phone,
          }, { emitEvent: false });
          this.accountSettingDisable = false;
          break;
        case 3:
          this.companyDetailsForm.patchValue({
            dealer_company_name: this.dealer_company_name,
            dealer_company_email: this.dealer_company_email,
          }, { emitEvent: false });
          this.companyDetailsDisable = false;
          break;
        case 4:
          this.companyAddressForm.patchValue({
            dealer_company_addresses: this.dealer_company_addresses,
            street: this.street,
            city: this.city,
            state: this.state,
            postal: this.postal,
            country: this.country,
            dealer_company_phone: this.dealer_company_phone,
          }, { emitEvent: false });
          this.companyAddressDisable = false;
          break;
      }
    } else {
      switch (form) {
        case 1:
          this.accountSettingFormChange();
          break;
        case 3:
          this.companyDetailsFormChange();
          break;
        case 4:
          this.companyAddressFormChange();
          break;
      }
    }
  }

  numericOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode == 101 || charCode == 69 || charCode == 45 || charCode == 46 || charCode == 43) {
      return false;
    }
    return true;
  }

  accountSettingFormChange() {
    const nameChanged = (this.accountSettingForm.value['dealer_name'] ?? '').toString().trim() !== (this.dealer_name ?? '').toString().trim();
    const emailChanged = (this.accountSettingForm.value['dealer_email'] ?? '').toString().trim() !== (this.dealer_email ?? '').toString().trim();
    const phoneChanged = (this.accountSettingForm.value['dealer_phone'] ?? '').toString().trim() !== (this.dealer_phone ?? '').toString().trim();

    this.accountSettingDisable = nameChanged || emailChanged || phoneChanged;
  }

  companyDetailsFormChange() {
    const nameChanged = (this.companyDetailsForm.value['dealer_company_name'] ?? '').toString().trim() !== (this.dealer_company_name ?? '').toString().trim();
    const emailChanged = (this.companyDetailsForm.value['dealer_company_email'] ?? '').toString().trim() !== (this.dealer_company_email ?? '').toString().trim();

    this.companyDetailsDisable = nameChanged || emailChanged;
  }

  companyAddressFormChange() {
    const streetChanged = (this.companyAddressForm.value['street'] ?? '').toString().trim() !== (this.street ?? '').toString().trim();
    const cityChanged = (this.companyAddressForm.value['city'] ?? '').toString().trim() !== (this.city ?? '').toString().trim();
    const stateChanged = (this.companyAddressForm.value['state'] ?? '').toString().trim() !== (this.state ?? '').toString().trim();
    const postalChanged = (this.companyAddressForm.value['postal'] ?? '').toString().trim() !== (this.postal ?? '').toString().trim();
    const countryChanged = (this.companyAddressForm.value['country'] ?? '').toString().trim() !== (this.country ?? '').toString().trim();
    const phoneChanged = (this.companyAddressForm.value['dealer_company_phone'] ?? '').toString().trim() !== (this.dealer_company_phone ?? '').toString().trim();

    this.companyAddressDisable = streetChanged || cityChanged || stateChanged || postalChanged || countryChanged || phoneChanged;
  }
}
